import React from "react";

const ReferralsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#4A4A4A"
      d="M.95 17.65q0-.874.45-1.587T2.65 15q1.825-.8 3.287-1.15a13 13 0 0 1 3.013-.35q1.55 0 3 .35T15.225 15q.8.35 1.263 1.063t.462 1.587v.85q0 .62-.44 1.06-.442.44-1.06.44h-13q-.62 0-1.06-.44a1.44 1.44 0 0 1-.44-1.06zM21.55 20H18.1q.124-.375.237-.737.114-.363.113-.763v-.85q0-1.575-.725-2.537-.724-.963-2.175-1.613 1.725.2 3.25.55t2.475.85q.825.475 1.3 1.175t.475 1.575v.85q0 .62-.44 1.06-.442.44-1.06.44m-12.6-8.025q-1.65 0-2.7-1.05t-1.05-2.7 1.05-2.7 2.7-1.05 2.7 1.05 1.05 2.7-1.05 2.7-2.7 1.05m9-3.75q0 1.65-1.05 2.7t-2.7 1.05a6 6 0 0 1-.612-.037 2.6 2.6 0 0 1-.613-.138q.6-.626.912-1.537.313-.913.313-2.038t-.312-1.987a5.3 5.3 0 0 0-.913-1.588 5.3 5.3 0 0 1 1.225-.175q1.65 0 2.7 1.05t1.05 2.7M2.45 18.5h13v-.85q0-.4-.237-.775a1.3 1.3 0 0 0-.588-.525q-1.8-.8-3.025-1.075T8.95 15t-2.663.275T3.25 16.35a1.24 1.24 0 0 0-.575.525q-.225.375-.225.775zm6.5-8.025q.975 0 1.613-.637.637-.638.637-1.613t-.637-1.612-1.613-.638-1.613.638T6.7 8.225t.637 1.613 1.613.637"
    ></path>
  </svg>
);

export default ReferralsIcon;
